module.exports = __webpack_public_path__ + "img/file-ident.23e5d8ab.svg";